import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import React, { useMemo } from 'react';
import { composeRenderProps, CheckboxGroup as CheckboxGroup$1 } from 'react-aria-components';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import Description from '../field/description.esm.js';
import FieldError from '../field/field-error/field-error.esm.js';
import Label from '../field/label/label.esm.js';

var _excluded = ["children", "className", "description", "errorMessage", "gap", "label", "layout", "screenReaderOnly"];

/**
 * A checkbox group allows a user to select multiple items from a list of options.
 */
function CheckboxGroup(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    _className = _ref$className === void 0 ? '' : _ref$className,
    description = _ref.description,
    errorMessage = _ref.errorMessage,
    gap = _ref.gap,
    label = _ref.label,
    layout = _ref.layout,
    screenReaderOnly = _ref.screenReaderOnly,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useComponentTheme('Checkbox');

  // note: this pattern of resolving the tailwind classes only works if it's
  // has no direct dependency on any state of renderProps from react-aria context.
  // if there are any style that are dependent on the state, we will  need to use data-xxx attribute
  // that react-aria provide to manage the style change.
  var _useMemo = useMemo(function () {
      var _theme$group = theme.group({
          gap: gap,
          layout: layout,
          screenReaderOnly: screenReaderOnly
        }),
        base = _theme$group.base,
        label = _theme$group.label,
        subText = _theme$group.subText;
      return {
        baseClasses: base(),
        labelClasses: label(),
        subTextClasses: subText()
      };
    }, [gap, layout, theme, screenReaderOnly]),
    baseClasses = _useMemo.baseClasses,
    labelClasses = _useMemo.labelClasses,
    subTextClasses = _useMemo.subTextClasses;
  var classes = useMemo(function () {
    return composeRenderProps(cn(baseClasses, _className), function (className) {
      return "csg-tw-select ".concat(className);
    });
  }, [baseClasses, _className]);
  return /*#__PURE__*/React.createElement(CheckboxGroup$1, _extends({
    className: classes
  }, props), label && /*#__PURE__*/React.createElement(Label, {
    className: labelClasses,
    ellipsis: "1"
  }, label), children, description && /*#__PURE__*/React.createElement(Description, {
    className: subTextClasses,
    ellipsis: "1"
  }, description), /*#__PURE__*/React.createElement(FieldError, {
    className: subTextClasses
  }, errorMessage));
}

export { CheckboxGroup };
//# sourceMappingURL=checkbox-group.esm.js.map
